import { HeaderFromPage } from "../../components/common/HeaderFormPage";
import { ChangePasswordFrom } from "../../components/ChangePasswordForm";
import styles from "./ChangePassword.module.scss";

export const ChangePassword = () => {
  return (
    <div className={styles.wrapper}>
      <HeaderFromPage title='Account settings' subtitle='Password' />
      <p className={styles.text}>
          Change your password below by filling in the from and receive
          an email conformation of the account changes.
      </p>
      <ChangePasswordFrom />
      <p className={styles.textBottom}>
        Forgot password? No problem,&nbsp;
        <strong>
          <a href='' className={styles.link}>
            Click here
          </a>
        </strong>
        .
      </p>
    </div>
  );
};
